import { useAccountNicknames } from '../hooks/useAccountNicknames'

export default function AccountName({ accountNumber, className = 'font-mono text-sm font-semibold text-ink' }) {
  const { getNickname } = useAccountNicknames()
  return <span className={className}>{getNickname(accountNumber)}</span>
}
